import React, { PropTypes } from 'react';

const ToggleGroupButton = ({ isOpen, closeGroup, openGroup }) => {
  const buttonText = isOpen ? 'Close Group' : 'Reopen Group';
  const action = isOpen ? closeGroup : openGroup;

  return (
    <button type="button" className="btn btn-primary btn-toggle" onClick={action}>
      { buttonText }
    </button>
  );
};

ToggleGroupButton.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeGroup: PropTypes.func.isRequired,
  openGroup: PropTypes.func.isRequired,
};

export default ToggleGroupButton;



// WEBPACK FOOTER //
// ./focus_groups/components/toggle_group_button.jsx